import React from "react";
import { ArrowUpRight } from "lucide-react";

/**
 * A single step in the VNG lifecycle timeline.
 * Renders the node, connector line, and a detail block with
 * summary, narrative, artifacts (chips) and a line-art icon.
 */
const VNGStep = ({ step, isLast, index }) => {
  const Icon = step.icon;

  return (
    <div
      data-testid={`vng-step-${step.id}`}
      className="grid grid-cols-[64px_1fr] gap-6 md:gap-10"
    >
      {/* Left rail: node + line */}
      <div className="flex flex-col items-center">
        <div
          className="rk-node"
          style={{ animationDelay: `${index * 80}ms` }}
        >
          <Icon strokeWidth={1} className="w-5 h-5" />
        </div>
        {!isLast && <div className="rk-line" />}
      </div>

      {/* Right rail: content */}
      <div className={`pb-16 ${isLast ? "" : ""} rk-fade-up`} style={{ animationDelay: `${index * 80}ms` }}>
        <div className="flex items-baseline gap-4 mb-3">
          <span
            className="overline text-[#C0C5CE]"
            data-testid={`vng-step-number-${step.id}`}
          >
            Stap {step.number}
          </span>
          <span className="text-[#9AA4B2] text-xs tracking-widest uppercase">
            {step.subtitle}
          </span>
        </div>

        <h3
          className="font-editorial text-3xl md:text-4xl tracking-tight text-white mb-4"
          style={{ fontFamily: "Fraunces, serif", fontWeight: 300 }}
          data-testid={`vng-step-title-${step.id}`}
        >
          {step.title}
        </h3>

        <p className="text-[#D4D8DF] text-base leading-relaxed max-w-2xl mb-5">
          {step.summary}
        </p>

        <p className="text-[#9AA4B2] text-sm leading-relaxed max-w-2xl mb-6">
          {step.narrative}
        </p>

        <div className="flex flex-wrap gap-2">
          {step.artifacts.map((a) => (
            <span
              key={a}
              className="rk-chip"
              data-testid={`vng-step-artifact-${step.id}-${a.replace(/\s+/g, "-").toLowerCase()}`}
            >
              {a}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VNGStep;
